module.exports = __webpack_public_path__ + "static/sa-144084855fbf52943a029c628696e505.svg";